import { render } from "./DealsList.vue?vue&type=template&id=0cecc6ea&scoped=true"
import script from "./DealsList.vue?vue&type=script&lang=js"
export * from "./DealsList.vue?vue&type=script&lang=js"

import "./DealsList.vue?vue&type=style&index=0&id=0cecc6ea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cecc6ea"]])

export default __exports__